export const queue = {
  type: {
    all: {
      title: 'All',
      description: 'The call comes to all operators.'
    },
    random: {
      title: 'Random',
      description: 'The call comes to a random operator.'
    }
  }
};
